export default __webpack_public_path__ + "static/media/NwabuezeChukwude.d7ba845b.svg";